const buildFunnelRequest = (projectId, sites, startDate, endDate, timeZone) => ({
  scope: { projectId },
  period: {
    startTime: new Date(startDate).toISOString(),
    // Dashboard date ranges end at 23:59:59; Analytics periods exclude endTime.
    endTime: new Date(new Date(endDate).getTime() + 1000).toISOString(),
    timeZone: timeZone || 'UTC'
  },
  selection: { siteIds: sites.map(site => site.id) }
});

const parseFunnelData = (response, sites) => {
  const points = response?.categorySeries?.points;
  if (!Array.isArray(points) || !Array.isArray(sites)) return [];

  const countsBySite = new Map(points.map(point => [point.key, Number(point.value || 0)]));
  return sites.map(site => ({
    value: countsBySite.get(site.id) || 0,
    label: site.stepName || site.displayName
  }));
};

export { buildFunnelRequest, parseFunnelData };
